import { createSlice } from "@reduxjs/toolkit";
import CryptoJS from "crypto-js";
import letter3Dictionary from "../../../database/Letter3Dictionary";

const secretKey = "my little secret";

export const encryptData = (data) => {
  const encryptedData = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    secretKey
  ).toString();
  return encryptedData;
};

export const decryptData = (encryptedData) => {
  const decryptedData = CryptoJS.AES.decrypt(encryptedData, secretKey).toString(
    CryptoJS.enc.Utf8
  );
  return JSON.parse(decryptedData);
};

function shuffleWord(word) {
  // Shuffle the characters of the word
  const characters = word.split("");
  for (let i = characters.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [characters[i], characters[j]] = [characters[j], characters[i]];
  }

  // Set the target length to 5
  const targetLength = 5;

  // Truncate or add random characters to make the length 5
  if (characters.length > targetLength) {
    characters.length = targetLength;
  } else {
    while (characters.length < targetLength) {
      const randomChar = String.fromCharCode(
        Math.floor(Math.random() * 26) + 97
      ); // Generating a random lowercase letter
      characters.push(randomChar);
    }
  }

  // Shuffle the characters again to ensure randomness
  for (let i = characters.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [characters[i], characters[j]] = [characters[j], characters[i]];
  }

  const shuffledWord = characters.join("");
  return shuffledWord;
}

const initialState =  {
      targetWord3: encryptData(
        letter3Dictionary[Math.floor(Math.random() * letter3Dictionary.length)]
      ),
      shuffleTargetWord3: "",
    };

const targetWord3Slice = createSlice({
  name: "targetWord3Slice",
  initialState,
  reducers: {
    setTargetWord3: (state, action) => {
      if (!state.targetWord3) {
        state.targetWord3 = encryptData(
          letter3Dictionary[
            Math.floor(Math.random() * letter3Dictionary.length)
          ]
        );
        state.shuffleTargetWord3 = shuffleWord(decryptData(state.targetWord3));
        return state;
      }
    },
    resetTargetWord3:(state,action)=>{
      state.targetWord3="";
      state.shuffleTargetWord3="";
      return state;
    }
  },
});
export const { setTargetWord3 ,resetTargetWord3} = targetWord3Slice.actions;
export default targetWord3Slice;
